import store from '../store'

// Cast env secure to a bool
let wsSecure = (process.env.VUE_APP_WS_SECURE == 'true' ? true : false) 

const OSC = require('osc-js')
const plugin = new OSC.WebsocketClientPlugin({
  host: process.env.VUE_APP_WS_ADDRESS,
  port: process.env.VUE_APP_WS_PORT,
  secure: wsSecure
})
const osc = new OSC({ plugin: plugin })

export function getOSCStatus () {
  // const status = osc.status();
  console.log('Checking OSC STATUS')
  console.log(osc.status())
  return osc.status()
}

export function startOSCConnection () {
  store.dispatch('osc/resetWSState')
  osc.open()
}

export function sendOscTriggerMessage (cueId) {
  sendMessage('/d3/showcontrol/cue', cueId)
}

export function sendOscDirectMessage (address, args) {
  console.log('SENDING direct OSC on address', address, 'with args', args)
  sendMessage(address, args)
}

export function sendMessage (address, message) {
  if (!Number.isInteger(message)) {
    message = Number(message)
  }

  osc.send(new OSC.Message(address, message))
}

export function receiveTrackNameMessage (trackname) {
  store.dispatch('osc/handleRecievedTrackNameMessage', {
    'trackname': trackname
  })
}

export function markWSOpen (trackname) {
  store.dispatch('osc/handleWSOpen')
}

osc.on('open', () => {
  console.log('OSC WS connection open')
  markWSOpen()
})

osc.on('/d3/showcontrol/trackname', (message) => {
  console.log('D3 track name received', message.args)
  console.log(message.args[0])
  receiveTrackNameMessage(message.args[0])
})
